import React from 'react';
import Paginations from '../../common/paginations';
import { Link } from 'react-router-dom';
import constant from '../../../constant';

const AssignModule = (props) => {
    const { data, limit, setCurrentPage } = props;
    const { roles, page, total } = data;

    return (
        <React.Fragment>
            <div className="table-responsive">
                <table className="table align-middle table-nowrap table-hover">
                    <thead className="table-light">
                        <tr>
                            <th scope="col" style={{ width: 70 }}>#</th>
                            <th scope="col">Role Name</th>
                            <th scope="col">Designations</th>
                        </tr>
                    </thead>
                    <tbody>
                        {roles?.map((item, index) => (
                            <tr key={item.ROLE_ID}>
                                <td>{(page - 1) * limit + index + 1}</td>

                                <td>
                                    <h5 className="font-size-14 mb-1">
                                        {item.ROLE_NAME}
                                        <span className={`badge border border-light rounded-circle ${item.STATUS === 'A' ? 'bg-success' : 'bg-warning'} p-1 ms-2`}>
                                            <span className="visually-hidden" />
                                        </span>
                                    </h5>
                                </td>

                                <td>
                                    {item.DESIGNATIONS?.length > 0 ? (
                                        item.DESIGNATIONS.map((des, idx) => (
                                            <React.Fragment key={des.DESIGNATION_ID}>
                                                <Link
                                                    to={{
                                                        pathname: constant.Authedcomponent.listModules.url,
                                                        state: {
                                                            designationId: JSON.stringify(des.DESIGNATION_ID)                                                        },
                                                    }}
                                                    className="badge bg-light text-primary fw-semibold me-2 mb-1"
                                                >
                                                    {des.DESIGNATION_NAME}
                                                </Link>
                                            </React.Fragment>
                                        ))
                                    ) : (
                                        <span className="text-muted">No Designation</span>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="d-flex justify-content-between align-items-center mt-3">
                <Paginations
                    limit={limit}
                    totalCount={total}
                    range={5}
                    currentPage={page}
                    onPageChange={setCurrentPage}
                />
            </div>
        </React.Fragment>
    );
};

export default AssignModule;
